import Ract from 'react';
import DefaultScreen from '@components/Global/DefaultScreenView';
import { Title } from '@constants/Themed';

const SalesLeads = () => {
  return (
    <DefaultScreen>
      <Title>Sales Leads Screen</Title>
    </DefaultScreen>
  )
}
export default SalesLeads;